<template>
  <div class="tableContainer">
      <navbar :device="device" @changeDevice="updateDevice" ></navbar>
      <md-card class="metricTable" v-if="error">
        <div class="alert alert-warning d-flex flex-column align-items-center mt-4" >
          <md-icon>error</md-icon> {{ error }}.
          <a href="javascript:void(0)" @click="fetchData()">Try Again</a>
        </div>
      </md-card>

      <md-card class="metricTable" v-else-if="new Date(device.timestamp).getTime()/1000 < Math.floor(new Date().getTime() / 1000)-(11 * 60)">
        <div class="alert alert-warning d-flex flex-column align-items-center mt-4" >
          Monitoring device is offline.
        </div>
      </md-card>

      <md-card class="metricTable pb-4" v-else>
        <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>
        <table class="table" v-else>
          <tr class="stats-row">
            <td style="width: 33%;">Metric</td>
            <td style="width: 33%;" @click="fetchData()">Current</td>
            <td style="width: 33%;">Preferred</td>
          </tr>
          <tbody>
            <tr v-for="(met, key, index) in device.metrics" :key="index">
              <td class="name">
                {{ met.short_name }} <span>{{ met.unit_symbol }}</span>
              </td>
              <td class="center">
                <span class="circle-badge" :class="getColor(met)">{{ met.value }}</span>
              </td>
              <td class="threholds center" v-if="met.thresholds.minimum">{{ met.thresholds.minimum }}-{{ met.thresholds.maximum }}</td>
              <td class="threholds center"  v-else>&lt; {{ met.thresholds.maximum }}</td>
            </tr>
          </tbody>

        </table>
      </md-card>

        <!--<div class="dev">
         <md-button v-if="!loading" @click="fetchData()" class="md-icon-button md-dense md-raised mb-2"> <md-icon>cached</md-icon> </md-button>
       </div>
     -->

    </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import api from '~/config/api';

export default {
  name: 'Dashboard',
  props: {
    msg: String
  },
  components: {Navbar},
  data() {
    return {
      loading: false,
      error: null,
      device: { metrics: {} }
    }
},
  methods: {
    async fetchData(){
      this.loading = true;
      this.error = null;
      let app = this;
      try {
        var res = await api.getMetricValues(this.$airsset_key);
          this.device = res.data;
      } catch (e) {
        console.log("Error: ", e);
        this.error = e.message;
      }
      this.loading = false;
      return true;
    },
    updateDevice(val){
      this.current_device = val;
    },
    getColor(met){
      if(met.value < met.thresholds.minimum || met.value > met.thresholds.maximum){
        return 'orange';
      }
      return 'green';
    }
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    metrics() {
      return Object.keys(this.device.metrics)
        //  .filter(value => !reject.includes(value))
          .reduce((carry, key) => {
              carry[key] = this.device.metrics[key];
              return carry;
          }, {});
    },
    device_(){
      return this.org.devices.length ? this.org.devices[this.current_device] : "Sample Device";
    },
    org_metricData() {
      return JSON.parse(this.org.metricData_config);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.metricTable {
  background: white !important;
  border-radius: 0;
  overflow-x: scroll;
}
table {
  background: white;
}
.circle-badge {
  border-radius: 50%;
  border: 0;
  text-align: center;
  display: inline-block;
  height: 3rem;
  width: 3rem;
  line-height: 3rem;
  font-weight: normal;
  color: white;
}

.orange {
  background-color: #FFA547;
}
.green {
  background-color: #7ACB38; /* #b6d7a9; */
}

tbody td{
  vertical-align: middle;
}

.stats-row > td {
  text-align: center;
  font-weight: normal;
}

td.name, td.threholds {
  text-align: center;
  font-weight: normal;
}
td.name span {
  color: #bcbcbc;
  font-weight: normal;
}

.center{
  text-align: center;
}

.dev {
  position: fixed;
  z-index: 2;
  top: 460px;
  left: 0%;
  opacity: 0.5;
  text-align: center;
  width: 380px;

}
</style>